import { OreButton, OreStack, SvgArrowLeft } from '@edenredespana/oreneta'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { AutoEnrollmentTranslation } from '@/AutoEnrollment/ui/autoEnrollmentTranslation'
import { useAutoEnrollment } from '@/AutoEnrollment/ui/context'
import { Step2Form } from '@/AutoEnrollment/ui/hooks'
import { formTranslation } from '@/Shared/ui/sharedTranslation'

export const Step2Actions = (): JSX.Element => {
  const { t } = useTranslation()
  const { handleSubmit, getValues, setError, setFocus } = useFormContext<Step2Form>()
  const { saveStep2, previousStep } = useAutoEnrollment()

  const saveAndContinue = async (
    event: React.MouseEvent<HTMLButtonElement>,
  ): Promise<void> => {
    if (getValues('storeLatitude') === null || getValues('storeLongitude') === null) {
      setError('storeStreet', {
        type: 'manual',
        message: t(AutoEnrollmentTranslation.storeAddressData.noPlacesError),
      })
    }

    if (
      !getValues('storeIsOnlineStore') &&
      !getValues('storeHasHomeDelivery') &&
      !getValues('storeHasLocalPickup')
    ) {
      setError('service', {
        type: 'manual',
        message: t(AutoEnrollmentTranslation.storeGeneralData.data.service.error),
      })

      setFocus('storeIsOnlineStore')

      return
    }

    event?.preventDefault()
    handleSubmit(saveStep2)()
  }

  return (
    <OreStack space="large" direction="row" placeContent="space-between">
      <OreButton category={'tertiary'} icon={<SvgArrowLeft />} onClick={previousStep}>
        {t(formTranslation.common.buttons.back)}
      </OreButton>
      <OreButton data-testid="saveStepTwo" category={'primary'} onClick={saveAndContinue}>
        {t(formTranslation.common.buttons.saveAndContinue)}
      </OreButton>
    </OreStack>
  )
}
